import { Component, OnInit, inject } from '@angular/core';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { AuthService } from "src/app/services/auth.service";
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';

@Component({
    selector: 'app-configuration',
    templateUrl: './configuration.component.html',
    styleUrls: ['./configuration.component.css'],
    standalone: false
})
export class ConfigurationComponent implements OnInit {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private configurationService = inject(ConfigurationService);
  private messageService = inject(MessageService);
  private authService = inject(AuthService);

  cols!: any[];
  records: any[] = [];
  totalCount: any = 0;
  scope: any = {
    key: null,
    value: null
  }
  config_id!: string | null
  isValid!: boolean
  configAddUpdate = false;
  showRiskScoring = false;
  current_user_email: string = this.authService.user.email;
  showNotificationManagement = false;

  ngOnInit(): void {
    this.cols = [
      { field: 'key', header: 'Key' },
      { field: 'value', header: 'Value' },
      { field: 'Actions', header: 'Actions' },
    ];
    const body = document.getElementsByTagName('body')[0];
    body.className = "";
    this.showNotificationManagement = environment.enableNotificationManagement;
    if(environment['userEmail'].includes(this.authService.user.email)){
      this.showRiskScoring = true;
    }
    body.classList.add('subpage');
  }
  loadRecordsLazy(event: any) {
    this.configurationService.getkeyValueList(event["first"]).subscribe(
      (res) => {
        this.totalCount = (res as any)["count"];
        this.records = (res as any)["docs"];
      }, (err) => {
        this.logger.exception(err)
      }
    );
  }
  showConfigAdd(){
    this.messageService.clear()
    this.config_id = null;
    this.scope.key = null;
    this.scope.value = null;
    this.configAddUpdate = true;
  }
  validateForm() {

    if (this.scope.key != null && this.scope.value != null) {
      this.isValid = true;
    } else {
      this.isValid = false;
    }
  }
  submitConfig() {
    this.configurationService.saveConfig(this.scope, this.config_id).subscribe(() => {
      const messageText=(this.config_id==null)?"Configuration Saved Successfully":"Configuration Updated Successfully";
      this.updateConfigList();
      this.scope.key = null
      this.scope.value = null
      this.config_id = null
      const message = {
        severity: 'success', sticky: true,
        summary: messageText,
        detail: '',
      }
      this.messageService.add(message);
    })
  }
  showUpdateConfig(config: any) {
    this.messageService.clear()
    this.config_id = config._id;
    this.scope.key = config.key;
    this.scope.value = config.value;
    this.configAddUpdate = true;
  }
  updateConfigList() {
    const obj = {};
    (obj as any)["first"] = 0;
    this.loadRecordsLazy(obj)
  }
  deleteConfig(row: any) {
    if (confirm("Are you sure that you want to Delete this?")){
      this.configurationService.deleteConfig(row._id).subscribe(() => {
        this.updateConfigList();
        const message = {
          severity: 'error', sticky: true,
          summary: "Deleted Successfully",
          detail: '',
        }
        this.messageService.add(message);
      })
    }
  }

  getUserRole(){
    return this.authService.user.role;
  }
}
